import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthContext'
import { HinweisProvider } from './hinweise/HinweisContext'
import { Geruest } from './komponenten/Geruest'
import { Ablagekonfiguration } from './seiten/Ablagekonfiguration'
import { Anmeldung } from './seiten/Anmeldung'
import { Bibliothek } from './seiten/Bibliothek'
import { DienstanalyseSeite } from './seiten/Dienstanalyse'
import { FahrzeugAkte } from './seiten/FahrzeugAkte'
import { FahrzeugStrecke } from './seiten/FahrzeugStrecke'
import { Kartenansicht } from './seiten/Kartenansicht'
import { Dienstplan } from './seiten/dienstplan/Dienstplan'
import { Turnusse } from './seiten/dienstplan/Turnusse'
import { Ausfallhilfe } from './seiten/disposition/Ausfallhilfe'
import { Disposition } from './seiten/disposition/Disposition'
import { Fahrplanwechsel } from './seiten/disposition/Fahrplanwechsel'
import { Klaerungen } from './seiten/Klaerungen'
import { KursDetail } from './seiten/KursDetail'
import { Kurse } from './seiten/Kurse'
import { MailEinstellungen } from './seiten/MailEinstellungen'
import { Mailvorlagen } from './seiten/Mailvorlagen'
import { Mandanten } from './seiten/Mandanten'
import { Gespraeche } from './seiten/Gespraeche'
import { Meldungen } from './seiten/Meldungen'
import { Betriebseinstellungen } from './seiten/Betriebseinstellungen'
import { Parameter } from './seiten/Parameter'
import { Posteingang } from './seiten/Posteingang'
import { StammdatenImport } from './seiten/StammdatenImport'
import { UmlaufbildungSeite } from './seiten/Umlaufbildung'
import { PasswortSetzen } from './seiten/PasswortSetzen'
import { Fahrpersonal } from './seiten/personal/Fahrpersonal'
import { Teams } from './seiten/personal/Teams'
import { Betriebshoefe, Fahrzeuge } from './seiten/Stammdaten'
import { Uebersicht } from './seiten/Uebersicht'
import { Zugaenge } from './seiten/Zugaenge'
import { Verkehrsmeldungen } from './seiten/verkehrsmeldungen/Verkehrsmeldungen'

function Router() {
  const { benutzer, laedt } = useAuth()
  const pfad = window.location.pathname

  // Einladung und Passwort-Zurücksetzung müssen ohne Anmeldung erreichbar sein —
  // genau die fehlt dem Aufrufer ja.
  if (pfad === '/einladung' || pfad === '/passwort-neu') {
    return <PasswortSetzen />
  }

  // Erst nach der Tokenprüfung entscheiden, sonst blitzt die Anmeldemaske kurz auf.
  if (laedt) {
    return <div className="laden">VLZHUB wird geladen …</div>
  }

  if (!benutzer) {
    return <Anmeldung />
  }

  return (
    <Routes>
      {/* Ohne Gerüst: Die Karte bekommt einen eigenen Tab und darin die ganze Fläche.
          Angemeldet sein muss man trotzdem — der Router kommt nur hierher, wenn ein
          Benutzer geladen ist. */}
      <Route path="/karte" element={<Kartenansicht />} />

      <Route element={<Geruest />}>
        <Route path="/" element={<Uebersicht />} />
        <Route path="/disposition" element={<Disposition />} />
        <Route path="/dienstplan" element={<Dienstplan />} />
        <Route path="/turnusse" element={<Turnusse />} />
        <Route path="/ausfall" element={<Ausfallhilfe />} />
        <Route path="/nachrichten" element={<Gespraeche />} />
        <Route path="/meldungen" element={<Meldungen />} />
        <Route path="/verkehrsmeldungen" element={<Verkehrsmeldungen />} />
        <Route path="/klaerungen" element={<Klaerungen />} />
        <Route path="/klaerungen/:id" element={<Klaerungen />} />
        <Route path="/kurse" element={<Kurse />} />
        <Route path="/analyse" element={<DienstanalyseSeite />} />
        <Route path="/umlaufbildung" element={<UmlaufbildungSeite />} />
        <Route path="/kurse/:id" element={<KursDetail />} />
        <Route path="/bibliothek" element={<Bibliothek />} />
        <Route path="/fahrplanwechsel" element={<Fahrplanwechsel />} />
        <Route path="/stammdaten-import" element={<StammdatenImport />} />
        <Route path="/fahrzeuge" element={<Fahrzeuge />} />
        <Route path="/fahrzeuge/:id" element={<FahrzeugAkte />} />
        <Route path="/fahrzeuge/:id/strecke" element={<FahrzeugStrecke />} />
        <Route path="/fahrer" element={<Fahrpersonal />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="/betriebshoefe" element={<Betriebshoefe />} />
        {/* Die Sichtbarkeit steuert zusaetzlich die Navigation; die verbindliche
            Rechtepruefung erfolgt im Backend. */}
        <Route path="/zugaenge" element={<Zugaenge />} />
        <Route path="/mandanten" element={<Mandanten />} />
        <Route path="/konfiguration" element={<Ablagekonfiguration />} />
        <Route path="/parameter" element={<Parameter />} />
        <Route path="/posteingang" element={<Posteingang />} />
        <Route path="/betriebseinstellungen" element={<Betriebseinstellungen />} />
        <Route path="/mail" element={<MailEinstellungen />} />
        <Route path="/mailvorlagen" element={<Mailvorlagen />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        {/* Innerhalb der Anmeldung: Der Hinweisdienst fragt als angemeldeter Benutzer. */}
        <HinweisProvider>
          <Router />
        </HinweisProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}
